import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Empty,
  Form,
  Input,
  Popconfirm,
  Row,
  Table,
  Tooltip,
  message,
} from "antd";
import UserServices from "../../services/UserServices";
import { FileAddOutlined } from "@ant-design/icons";
import AddPatientMedicine from "../Modals/AddPatientMedicine";
import {
  LoadingOutlined,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { get_language, translate } from "../../locale";
import moment from "moment";
import DashServices from "../../services/DashServices";
import InviteUser from "../Modals/InviteUser";
import { TableHelper } from "../../helpers/TableHelper";

import NotificationsTable from "./NotificationsTable";

const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />
);

const SubscriptionUsers = ({ subscription, reload }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [modalAddUser, setModalAddUser] = useState(false);
  const navigate = useNavigate();
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
      total: 0,
    },
    searchText: "",
  });
  const [total, setTotal] = useState(0);

  const columns = [
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <div className="flex space-x-2 justify-center">
          <Tooltip title={translate("Editar")} color="blur">
            <Button
              shape="circle"
              icon={<EditOutlined />}
              size="small"
              className="border-none"
              onClick={() => {
                navigate(
                  `/admin/buscar-paciente/${record.username}/personal-details`
                );
              }}
            />
          </Tooltip>
          <Popconfirm
            title={
              <>
                ¿Está seguro de que quiere desvincular este usuario de la
                suscripción?
                <br />
                Esta acción no se puede deshacer.
              </>
            }
            okText="Si"
            cancelText="No"
            onConfirm={() => {
              desusbscribeUser(record.username);
            }}
          >
            <Tooltip title="Eliminar" color="blur">
              <Button
                type="text"
                icon={<DeleteOutlined />}
                size="small"
                className="border-0"
              />
            </Tooltip>
          </Popconfirm>
        </div>
      ),
    },
    {
      title: translate("Usuario"),
      dataIndex: "username",
      key: "username",
      render: (_, record) => {
        if (record.user.provider === "cronic") return record.username;

        return (
          <a
            onClick={() =>
              navigate(
                `/admin/buscar-paciente/${record.user.username}/personal-details`
              )
            }
            className="text-black hover:text-custom_primary"
          >
            {record.username}
          </a>
        );
      },
      sorter: (a, b) => {
        if (a.username < b.username) return -1;
        if (a.username > b.username) return 1;
        return 0;
      },
    },
    {
      title: translate("Última actividad"),
      dataIndex: "last_activity",
      key: "last_activity",
      render: (value, record, index) => {
        const date =
          record.last_activity !== null
            ? moment(record.last_activity).format(
                get_language === "en" ? "MM/DD/YYYY" : "DD/MM/YYYY"
              )
            : "-";
        return date;
      },
      sorter: (a, b) => {
        if (a.last_activity < b.last_activity) return -1;
        if (a.last_activity > b.last_activity) return 1;
        return 0;
      },
    },
    {
      title: translate("Invitado por"),
      dataIndex: "invited_by",
      key: "invited_by",
      sorter: (a, b) => {
        if (a.invited_by < b.invited_by) return -1;
        if (a.invited_by > b.invited_by) return 1;
        return 0;
      },
    },
  ];

  useEffect(() => {
    if (subscription !== null && subscription.id !== undefined) {
      let data = {
        page_size: tableParams.pagination.pageSize,
        page_num: tableParams.pagination.current,
      };
      const sorter = TableHelper.sorter(tableParams);
      if (sorter !== null) {
        data = { ...data, order_by: sorter };
      }
      loadUsers(data);
    }
  }, [subscription, reload]);

  useEffect(() => {
    let data = {
      page_size: tableParams.pagination.pageSize,
      page_num: tableParams.pagination.current,
    };
    const sorter = TableHelper.sorter(tableParams);
    if (sorter !== null) {
      data = { ...data, order_by: sorter };
    }
    if (tableParams.searchText !== "") {
      data = { ...data, text: tableParams.searchText };
    }
    loadUsers(data);
  }, [JSON.stringify(tableParams)]);

  const loadUsers = async (data) => {
    if (subscription.id === undefined) return;
    setLoading(true);
    try {
      const res = await UserServices.getSubscriptionUser(
        data,
        subscription.id,
        "eira-patient"
      );
      if (res.status >= 200 && res.status < 300) {
        const newData = res.data.users.map((pro) => ({
          id: pro.profile.user.id,
          username: pro.profile.user.username,
          last_activity: pro.last_activity,
          invited_by:
            pro.invited_by !== null
              ? pro.invited_by.full_name
              : translate("Sin invitación"),
          user: pro.profile.user,
        }));
        setData(newData);
        setFilteredUsers(newData);
        setTotal(res.data.total_pages * tableParams.pagination.pageSize);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleModalCancel = () => {
    setModalVisible(false);
  };
  const handleModalComplete = () => {
    setModalVisible(false);
  };

  const desusbscribeUser = async (username) => {
    try {
      setLoading(true);
      const res = await DashServices.deleteSubscriptionsUser(
        subscription.id,
        username
      );
      if (res.status >= 200 && res.status < 300) {
        message.success(
          translate("El {0} se desviculó exitosamente.", translate("usuario"))
        );
        loadUsers();
      } else {
        message.error(res.data.detail);
      }
      setLoading(false);
    } catch (error) {
      console.log("error", error);
      message.error(error);
      setLoading(false);
    }
  };
  const searchUser = (value) => {
    setTableParams((v) => ({
      pagination: {
        ...v.pagination,
        current: 1,
      },
      searchText: value,
    }));
  };
  const addUser = () => {
    setModalAddUser(true);
  };
  const handleCancelAddUser = () => {
    setModalAddUser(false);
  };
  const handleCompleteAddUser = (refresh) => {
    setModalAddUser(false);
    if (refresh) {
      loadUsers();
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams((v) => ({
      ...v,
      pagination,
      filters,
      sorter,
    }));

    // `dataSource` is useless since `pageSize` changed
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };

  return (
    <>
      <Row gutter={16}>
        <Col span="18" className="mb-4">
          <Tooltip
            placement="topLeft"
            title={
              subscription?.modules && subscription.modules.length === 0
                ? translate("La suscripción no tiene modulos")
                : null
            }
            className="rounded"
          >
            <Button
              onClick={addUser}
              className="bg-white text-custom_darkgray hover:text-custom_primary hover:border-custom_primary mr-6"
              disabled={
                subscription?.modules && subscription.modules.length === 0
              }
            >
              {translate("Invitar usuario")}
            </Button>
          </Tooltip>
          <InviteUser
            subscriptionId={subscription.id}
            visible={modalAddUser}
            onCancel={handleCancelAddUser}
            onComplete={handleCompleteAddUser}
            rol={"patient"}
            enterpriseId={
              subscription?.enterprise && subscription.enterprise.id
            }
          />
          <Button
            onClick={() =>
              navigate("/admin/pending-patients-invitations", {
                state: { subscription },
              })
            }
            className="bg-white text-custom_darkgray hover:text-custom_primary hover:border-custom_primary mr-6"
          >
            {translate("Invitaciones pendientes")}
          </Button>
        </Col>
        <Col span="6" className="mb-4">
          <Form>
            <Form.Item>
              <Input.Search
                allowClear
                placeholder={translate("Buscar")}
                onSearch={searchUser}
              />
            </Form.Item>
          </Form>
        </Col>
      </Row>
      <Table
        dataSource={filteredUsers}
        columns={columns}
        rowKey={(v) => v.id.toString()}
        loading={
          loading
            ? { indicator: antIcon, className: "text-custom_blue" }
            : false
        }
        locale={{
          emptyText: <Empty description={translate("No hay datos")} />,
          sortTitle: translate("Ordenar"),
          triggerDesc: translate("Ordenar (descendente)"),
          triggerAsc: translate("Ordenar (ascendente)"),
          cancelSort: translate("Cancelar orden"),
        }}
        pagination={{ ...tableParams.pagination, total: total }}
        onChange={handleTableChange}
      />

      <AddPatientMedicine
        visible={modalVisible}
        subscription={subscription}
        patient={selectedUser}
        onCancel={handleModalCancel}
        onComplete={handleModalComplete}
      />
    </>
  );
};

export default SubscriptionUsers;
